import * as React from 'react';
import { Modal, Form, Input, Switch, Button, Divider } from 'antd';
// import { PlusOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';

import { SingleProductContext } from '../context/SingleProductContext';

export default function NewIngredientModal() {
  const {
    showIngredientModal,
    setShowIngredientModal,
    newIngredientValue,
    setNewIngredientValue,
    addNewIngredientHandler,
  } = React.useContext(SingleProductContext);

  return (
    <Modal
      title='เพิ่ม Ingredient ใหม่'
      visible={showIngredientModal}
      onOk={() => {
        if (newIngredientValue) addNewIngredientHandler();
      }}
      onCancel={() => setShowIngredientModal(false)}>
      <Input
        status={newIngredientValue ? null : 'error'}
        value={newIngredientValue}
        onChange={(e) => {
          setNewIngredientValue(e.target.value);
        }}
      />
      {newIngredientValue ? null : <span style={{ color: 'red' }}>กรุณาระบุ Ingredient</span>}
    </Modal>
  );
}
